/* ThaBel — home: carrossel de banners, trilhos com setas, abas da vitrine */
(() => {
  if (window.tbHomePronto) return;
  window.tbHomePronto = true;
  const semMovimento = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Carrossel de banners */
  class TbCarrossel extends HTMLElement {
    connectedCallback() {
      this.trilho = this.querySelector('[data-trilho]');
      this.slides = [...this.querySelectorAll('[data-slide]')];
      this.pontos = [...this.querySelectorAll('[data-ponto]')];
      this.atual = 0;
      if (this.slides.length < 2) return;
      this.querySelector('[data-ant]')?.addEventListener('click', () => { this.ir(this.atual - 1); this.parar(true); });
      this.querySelector('[data-prox]')?.addEventListener('click', () => { this.ir(this.atual + 1); this.parar(true); });
      this.pontos.forEach((p) => p.addEventListener('click', () => { this.ir(Number(p.dataset.ponto)); this.parar(true); }));
      this.pausa = this.querySelector('[data-pausa]');
      this.pausa?.addEventListener('click', () => this.parar(true));
      if ('IntersectionObserver' in window) {
        const obs = new IntersectionObserver((es) => {
          es.forEach((e) => { if (e.isIntersecting) this.marcar(this.slides.indexOf(e.target)); });
        }, { root: this.trilho, threshold: 0.6 });
        this.slides.forEach((s) => obs.observe(s));
      }
      this.addEventListener('mouseenter', () => this.parar());
      this.addEventListener('mouseleave', () => this.iniciar());
      this.addEventListener('focusin', () => this.parar());
      this.iniciar();
    }
    ir(i) {
      const n = (i + this.slides.length) % this.slides.length;
      this.trilho.scrollTo({ left: this.slides[n].offsetLeft, behavior: semMovimento ? 'auto' : 'smooth' });
      this.marcar(n);
    }
    marcar(n) {
      this.atual = n;
      this.pontos.forEach((p, k) => {
        p.classList.toggle('is-ativo', k === n);
        if (k === n) p.setAttribute('aria-current', 'true'); else p.removeAttribute('aria-current');
      });
    }
    iniciar() {
      const s = Number(this.dataset.auto || 0);
      if (!s || semMovimento || this.parado) return;
      clearInterval(this.timer);
      this.timer = setInterval(() => this.ir(this.atual + 1), s * 1000);
      if (this.pausa) this.pausa.hidden = false;
    }
    parar(definitivo) {
      clearInterval(this.timer);
      if (definitivo) { this.parado = true; if (this.pausa) this.pausa.hidden = true; }
    }
  }
  if (!customElements.get('tb-carrossel')) customElements.define('tb-carrossel', TbCarrossel);

  /* Trilho horizontal com setas */
  class TbTrilho extends HTMLElement {
    connectedCallback() {
      this.lista = this.querySelector('[data-trilho]');
      this.ant = this.querySelector('[data-ant]');
      this.prox = this.querySelector('[data-prox]');
      if (!this.lista) return;
      const passo = () => Math.max(200, this.lista.clientWidth * 0.8);
      this.ant?.addEventListener('click', () => this.lista.scrollBy({ left: -passo(), behavior: semMovimento ? 'auto' : 'smooth' }));
      this.prox?.addEventListener('click', () => this.lista.scrollBy({ left: passo(), behavior: semMovimento ? 'auto' : 'smooth' }));
      this.lista.addEventListener('scroll', () => this.atualizar(), { passive: true });
      window.addEventListener('resize', () => this.atualizar());
      this.atualizar();
    }
    atualizar() {
      const max = this.lista.scrollWidth - this.lista.clientWidth - 2;
      if (this.ant) this.ant.disabled = this.lista.scrollLeft <= 2;
      if (this.prox) this.prox.disabled = this.lista.scrollLeft >= max;
      this.classList.toggle('sem-rolagem', max <= 0);
    }
  }
  if (!customElements.get('tb-trilho')) customElements.define('tb-trilho', TbTrilho);

  /* Abas (vitrine) */
  class TbAbas extends HTMLElement {
    connectedCallback() {
      this.abas = [...this.querySelectorAll('[role="tab"]')];
      this.abas.forEach((aba, i) => {
        aba.addEventListener('click', () => this.ativar(i));
        aba.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
            e.preventDefault();
            const n = (i + (e.key === 'ArrowRight' ? 1 : -1) + this.abas.length) % this.abas.length;
            this.ativar(n); this.abas[n].focus();
          }
        });
      });
    }
    ativar(i) {
      this.abas.forEach((aba, k) => {
        const ativa = k === i;
        aba.setAttribute('aria-selected', ativa ? 'true' : 'false');
        aba.tabIndex = ativa ? 0 : -1;
        const painel = document.getElementById(aba.getAttribute('aria-controls'));
        if (painel) {
          painel.hidden = !ativa;
          if (ativa) painel.querySelector('tb-trilho')?.atualizar?.();
        }
      });
    }
  }
  if (!customElements.get('tb-abas')) customElements.define('tb-abas', TbAbas);
})();

/* Avaliações da home em ordem aleatória a cada visita */
document.querySelectorAll('[data-embaralhar]').forEach((lista) => {
  const itens = Array.from(lista.children);
  for (let i = itens.length - 1; i > 0; i -= 1) {
    const j = Math.floor(Math.random() * (i + 1));
    [itens[i], itens[j]] = [itens[j], itens[i]];
  }
  itens.forEach((li) => lista.appendChild(li));
});

/* Avaliações da home: "Ler mais" aparece só quando o texto passa de 4 linhas e abre a avaliação inteira numa janela */
function tbConferirLerMais() {
  document.querySelectorAll('[data-tb-texto-av]').forEach((p) => {
    const botao = p.parentElement.querySelector('[data-tb-ler-mais]');
    if (!botao || !p.clientHeight) return;
    botao.classList.toggle('is-escondido', p.scrollHeight <= p.clientHeight + 2);
  });
}
tbConferirLerMais();
window.addEventListener('load', tbConferirLerMais);
window.addEventListener('resize', tbConferirLerMais);
if (!window.__tbAvCompleta) {
  window.__tbAvCompleta = true;
  document.addEventListener('click', (e) => {
    const botao = e.target.closest('[data-tb-ler-mais]');
    if (!botao) {
      const d = e.target.closest('.tb-av-completa');
      if (d && (e.target === d || e.target.closest('.tb-av-completa__fechar'))) d.close();
      return;
    }
    let d = document.querySelector('.tb-av-completa');
    if (!d) {
      d = document.createElement('dialog');
      d.className = 'tb tb-av-completa';
      document.body.appendChild(d);
    }
    d.innerHTML = '<button type="button" class="tb-av-completa__fechar" aria-label="Fechar">×</button>';
    const card = botao.closest('.tb-av-loja__card').cloneNode(true);
    card.querySelectorAll('[data-tb-foto]').forEach((a) => { a.dataset.tbFoto = 'av-janela'; });
    d.appendChild(card);
    d.showModal();
  });
}
